import { useFilters } from "../providers/FiltersProvider";
import { ScheduleLessonsListView } from "../views/ScheduleLessonsListView";

export default function LessonsList() {
  const { lessons } = useFilters();

  return <ScheduleLessonsListView lessons={lessons} />;
}
